__turbopack_context__.v({
  "divider": "_1ROFLW_divider",
  "memberBorder": "_1ROFLW_memberBorder",
  "members": "_1ROFLW_members",
  "root": "_1ROFLW_root",
  "searchBar": "_1ROFLW_searchBar",
  "searchInput": "_1ROFLW_searchInput",
  "title": "_1ROFLW_title",
});
